import { useState, useEffect, useRef, useCallback } from "react";

export type WindowSize = {
  width: number;
  height: number;
  ratio: number;
};

function useWindowSize() {
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: typeof document !== 'undefined' ? document.body.clientWidth : 0,
    height: typeof document !== 'undefined' ? document.body.clientHeight : 0,
    ratio: 1,
  });

  const timeoutRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  const handleResize = useCallback(() => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      const newWidth = document.body.clientWidth;
      const newHeight = document.body.clientHeight;
      const newRatio = newWidth / newHeight;
      setWindowSize((prev) => {
        if (prev.width === newWidth && prev.height === newHeight) return prev;
        return { width: newWidth, height: newHeight, ratio: newRatio };
      });
    }, 200);
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [handleResize]);

  return windowSize;
}

export default useWindowSize;
